// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestScrollingContainer {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _testScrollingContainerX?: vf.gui.ScrollingContainer;

    private _testScrollingContainerY?: vf.gui.ScrollingContainer;

    private _testScrollingContainerXY?: vf.gui.ScrollingContainer;

    private _buttonList: vf.gui.Label[] = [];

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 滚动容器 水平拖动 */
        const scX = this._testScrollingContainerX = this.addSc(uiStage, 50, 40, "水平拖动");
        scX.scrollX = true;
        scX.dragScrolling = true;//是否启用拖动滚动

        /** 滚动容器 垂直拖动 */
        const scY = this._testScrollingContainerY = this.addSc(uiStage, 50, 260, "垂直拖动");
        scY.dragScrolling = true;//是否启用拖动滚动
        scY.scrollY = true;

        /** 滚动容器 垂直水平拖动 */
        const scXY = this._testScrollingContainerXY = this.addSc(uiStage, 50, 480, "任意拖动");
        scXY.dragScrolling = true;//是否启用拖动滚动
        scXY.scrollX = true;
        scXY.scrollY = true;


        this.getButton('设置/取消scrollX', () => {

            if (scX.scrollX !== false) {

                scX.scrollX = false;
            } else {
                scX.scrollX = true;
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消scrollY', () => {

            if (scY.scrollY !== false) {

                scY.scrollY = false;
            } else {
                scY.scrollY = true;
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消 dragScrolling', () => {

            if (scXY.dragScrolling !== false) {

                scXY.dragScrolling = false;
            } else {
                scXY.dragScrolling = true;
            }
        }, uiStage, 650, 0);




















    }

    private addSc(uiStage: vf.gui.Stage, x: number, y: number, label: string) {


        const sc = new vf.gui.ScrollingContainer();
        sc.style.left = x;
        sc.style.top = y;
        sc.style.width = 300;
        sc.style.height = 200;
        sc.expandMask = 2;
        sc.softness = 0.2;
        uiStage.addChild(sc);

        const title = new vf.gui.Label(label);
        title.style.color = 0xffcc00;
        sc.addChild(title);

        for (let i = 0; i < 5; i++) {
            const sp = new vf.gui.Image();
            sp.style.top = i * 620;
            sp.src = "assets/sprite.png";
            sc.addChild(sp);
        }
        return sc;
    }


    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }

    private onRelease() {
        if (this._testScrollingContainerX) {
            this._testScrollingContainerX.removeAllListeners();
            this._testScrollingContainerX.parent && this._testScrollingContainerX.parent.removeChild(this._testScrollingContainerX);
            this._testScrollingContainerX.release();
            this._testScrollingContainerX = undefined;
        }
        if (this._testScrollingContainerY) {
            this._testScrollingContainerY.removeAllListeners();
            this._testScrollingContainerY.parent && this._testScrollingContainerY.parent.removeChild(this._testScrollingContainerY);
            this._testScrollingContainerY.release();
            this._testScrollingContainerY = undefined;
        }
        if (this._testScrollingContainerXY) {
            this._testScrollingContainerXY.removeAllListeners();
            this._testScrollingContainerXY.parent && this._testScrollingContainerXY.parent.removeChild(this._testScrollingContainerXY);
            this._testScrollingContainerXY.release();
            this._testScrollingContainerXY = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }


}

